// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".textarea-notes[data-v-543dabde]{resize:none;min-height:86px}.textarea-notes[data-v-543dabde]:focus{outline:transparent;box-shadow:none}.notes-form[data-v-543dabde]{word-break:break-word}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
